<template>
  <div class="tinymce-editor">
    <editor v-model="myValue" :init="init" :disabled="disabled"></editor>
  </div>
</template>
<script>
import tinymce from 'tinymce';
import Editor from '@tinymce/tinymce-vue';
// import "../../../content-service/public/tinymce/themes/silver";
// import "../../../content-service/public/tinymce/plugins/paste";
// import "../../../content-service/public/tinymce/plugins/image";
// import "../../../content-service/public/tinymce/plugins/link";
// import "../../../content-service/public/tinymce/plugins/code";
// import "../../../content-service/public/tinymce/plugins/table";
// import "../../../content-service/public/tinymce/plugins/lists";
// import "../../../content-service/public/tinymce/plugins/insertmap";
// import "../../../content-service/public/tinymce/plugins/insertact";
// import "../../../content-service/public/tinymce/plugins/wordcount";
window.tinymce.baseURL = '/tinymce';

export default {
  components: {
    Editor,
  },
  props: {
    content: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default: 'link lists image code table insertmap insertact',
    },
    toolbar: {
      type: [String, Array],
      default:
        'bold italic underline strikethrough | fontsizeselect fontselect | forecolor backcolor | insertmap insertact | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink code | removeformat',
    },
  },
  data() {
    return {
      init: {
        base_url: '/tinymce',
        // language_url: "tinymce/langs/zh_CN.js", //如果语言包不存在，指定一个语言包路径
        language: 'zh_CN', //语言
        // skin_url: "tinymce/skins/ui/oxide", //如果主题不存在，指定一个主题路径
        // content_css: "tinymce/mycontent.css",
        height: '700px',
        width: '100%',
        plugins: this.plugins, //插件
        toolbar: this.toolbar, //工具栏
        branding: false, //技术支持(Powered by Tiny || 由Tiny驱动)
        menubar: true, //菜单栏
        theme: 'silver', //主题
        zIndex: 1101,
      },
      myValue: this.content,
    };
  },
  mounted() {
    tinymce.init({
      base_url: '/tinymce',
    });
  },
  methods: {
    calcWidth() {
      return document.body.clientWidth / 2 + 'px';
    },
  },
  watch: {
    content(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      this.$emit('update', newValue);
    },
  },
};
</script>
